import { WorkerPrintContainer } from './WorkerPrintContainer';

const name = 'PrintContainer';

export { WorkerPrintContainer, name };
